define([
    "./userManagementLGPDModule",
], function (userManagementLGPDModule) {
    "use strict";

    userManagementLGPDModule.config(["lgpdApiByArtifactProvider", function (lgpdApiByArtifact) {
        lgpdApiByArtifact.addArtifactApi("userManagement", "userManagementLgpdApi")
    }]);
});